import { useNavigate } from "react-router-dom";
import { useToast } from "duck";
import { useResetPasswordMutation } from "requests";
import { FormValues } from "./types";

export const useResetPassword = () => {
  const navigate = useNavigate();
  const [resetPassword] = useResetPasswordMutation();

  const toast = useToast();

  return ({ email }: FormValues) =>
    resetPassword({ variables: { email } }).then(() => {
      toast({
        title: "Email is sent",
        description: `Email with instructions for recovering a password is sent to ${email}. If you have not received the letter, then check Spam. Your existing password has not been changed.`,
        status: "success",
        isClosable: true
      });

      navigate("/", { replace: true });
    });
};
